// @ts-nocheck
/* eslint-disable */
import { addListener, removeListener } from "~/lib/signals";
import { altitudeProfile } from "~/util/providers/altitude";
import { Scene, _, CONFIG } from "~/route/globals";
import { buildSummaryModule } from "./main";
import InteractiveLineChart from "~/interactivelinechart";
import createSDSIcon from "~/ui/icon";
import { ROUTE_HEIGHT_PROFILE } from "~/ui/sds-compatible-icons";

const PADDING = 2 * 33;

export default class ModuleHeightProfile {
	constructor(responseData, routeState) {
		this._responseData = responseData;
		this._elms = buildSummaryModule({
			title: _("lineChart.title"),
			sdsIcon: createSDSIcon({ className: "icon-height-profile", symbol: ROUTE_HEIGHT_PROFILE }),
			className: "route-height-profile content",
			headerClassName: "route-height-profile-form-header",
			switcher: false
		});
		this._elms.loader = Mapy.Util.node("div", { className: "loader-big" });
		this._elms.loader.appendChild(Mapy.Util.node("img", { src: "/img/loader.gif", width: 24, height: 24 }));

		this._opened = routeState.heightProfile;
		this._prevOffsetWidth = -1;
		this._lineChart = null;
		this._rpc = null;
		this._container = this._elms.container;
		this._elms.header.addEventListener("click", this, false);
		// signaly
		this._resizeHandler = () => {
			this._resize();
		};
		this._resizeSignal = addListener(this, "resize", this._resizeHandler);
		window.addEventListener("map-marker-show", this);
		window.addEventListener("map-marker-hide", this);
		this._lids = [];
		this._lids.push(Mapy.CML.addListener(print => {
			if (!this._lineChart) return;

			if (Mapy.getComponent("print").mode != 4) {
				this._lineChart.setData(undefined, undefined, {
					width: print ? 700 : Mapy.getComponent("layout").getBody().offsetWidth - PADDING
				});
			}
		}, "route.print"));

		this._set();
	}

	destroy() {
		Mapy.CML.removeListeners(this._lids);
		removeListener(this._resizeSignal);
		window.removeEventListener("map-marker-show", this);
		window.removeEventListener("map-marker-hide", this);
		this._resizeSignal = null;
		if (this._lineChart) {
			this._lineChart.destroy();
			this._lineChart = null;
		}
		if (this._interactive) {
			this._interactive.destroy();
			this._interactive = null;
		}
		this._elms.header.removeEventListener("click", this, false);
		this._container.remove();
	}

	get container() {
		return this._container;
	}

	reloadState() {
		const routeState = Mapy.CML.state.route;

		this._opened = routeState.heightProfile;

		if (routeState.responseData) {
			this._responseData = routeState.responseData[routeState.index];
		}

		this._container.classList[this._opened ? "add" : "remove"]("open");
		this._set();
	}

	handleEvent(e) {
		switch (e.type) {
			case "click":
				this._opened = !this._opened;
				this._container.classList[this._opened ? "add" : "remove"]("open");

				Mapy.CML.state = {
					route: {
						heightProfile: this._opened
					}
				};

				this._set();

				Mapy.getComponent("logger").log("click", { text: this._opened ? "Zobrazit výškový profil" : "Skrýt výškový profil" });
				break;

			case "map-marker-show":
				if (this._interactive) {
					this._interactive.show(e.detail.frac, true);
				}
				break;

			case "map-marker-hide":
				if (this._interactive) {
					this._interactive.hide();
				}
				break;
		}
	}

	_set() {
		this._container.classList[this._opened ? "add" : "remove"]("open");

		if (this._opened) {
			if (!this._lineChart) {
				this._makeProfileFromData();
			} else {
				this._elms.switcherContainer.appendChild(this._lineChart.getContainer());
			}
		}
		else {
			if (this._lineChart) {
				this._lineChart.getContainer().remove();
			}
		}
	}

	_makeProfileFromData() {
		let altitudeData = null;

		if (this._responseData) {
			altitudeData = this._responseData.altitude;
		}

		if (altitudeData?.data) {
			this._makeProfile(altitudeData);
		} else {
			this._loadAltitudeData();
		}
	}

	_makeProfile(altitudeData) {
		if (this._rpc) {
			Mapy.getComponent("loader").end(true);
			this._elms.switcherContainer.classList.remove("loading");
			this._elms.loader.remove();
			this._rpc = null;
		}

		this._lineChart = new LineChart(altitudeData, this._responseData.totalLength, {
			width: Mapy.getComponent("layout").getBody().offsetWidth - PADDING,
			noTitle: true
		});
		this._elms.switcherContainer.appendChild(this._lineChart.getContainer());
		this._interactive = new InteractiveLineChart(this._lineChart, {
			getCoords: () => Scene.stringToCoords(this._responseData.geometry),
			config: CONFIG,
		});

		this._resize();
	}

	_resize() {
		if (this._lineChart) {
			let width = Mapy.getComponent("layout").getBody().offsetWidth - PADDING;

			if (this._prevOffsetWidth != width) {
				this._lineChart.setData(undefined, undefined, {
					width
				});
				this._prevOffsetWidth = width;
			}
		}
	}

	_loadAltitudeData() {
		if (this._rpc) {
			this._rpc.request.abort();
			this._rpc = null;
			Mapy.getComponent("loader").end(true);
			this._elms.switcherContainer.classList.remove("loading");
		}

		Mapy.getComponent("loader").start(true, true);
		this._elms.switcherContainer.appendChild(this._elms.loader);
		this._elms.switcherContainer.classList.add("loading");

		this._rpc = altitudeProfile(this._responseData.geometry);
		this._rpc.promise.then(data => {
			this._makeProfile(data.altitude);
		}, e => {});
	}
}
